var render = function () {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c(
    "vx-card",
    {
      attrs: {
        title: _vm.id === null ? "Cadastrar Estudante" : "Editar Estudante",
      },
    },
    [
      _c(
        "vs-tabs",
        {
          attrs: { color: _vm.colorx },
          model: {
            value: _vm.tabIndex,
            callback: function ($$v) {
              _vm.tabIndex = $$v
            },
            expression: "tabIndex",
          },
        },
        [
          _c(
            "vs-tab",
            { attrs: { label: "Dados Básicos" } },
            [
              _c("StudentForm", {
                attrs: {
                  services: _vm.services,
                  studentId: _vm.computedId,
                  studentEntity: _vm.studentEntity,
                },
                on: { "update-data": _vm.handleUpdateDataStudent },
              }),
            ],
            1
          ),
          _c(
            "vs-tab",
            { attrs: { label: "Endereço", disabled: _vm.isTabEnabled } },
            [
              _vm.studentEntity.people_id
                ? _c("Address", {
                    attrs: {
                      services: _vm.services,
                      people_id: _vm.studentEntity.people_id,
                    },
                  })
                : _vm._e(),
            ],
            1
          ),
          _c(
            "vs-tab",
            { attrs: { label: "Telefone", disabled: _vm.isTabEnabled } },
            [
              _vm.studentEntity.people_id
                ? _c("Phone", {
                    attrs: {
                      services: _vm.services,
                      people_id: _vm.studentEntity.people_id,
                    },
                  })
                : _vm._e(),
            ],
            1
          ),
          _c(
            "vs-tab",
            { attrs: { label: "Email", disabled: _vm.isTabEnabled } },
            [
              _vm.studentEntity.people_id
                ? _c("Email", {
                    attrs: {
                      services: _vm.services,
                      people_id: _vm.studentEntity.people_id,
                    },
                  })
                : _vm._e(),
            ],
            1
          ),
        ],
        1
      ),
    ],
    1
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }